import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
    nameLat: Yup.string()
        .required("Le nom est obligatoire")
        .max(150, "150 caractères max"),

    descriptionLat: Yup.string()
        .max(500, "500 caractères max"),
});

const baseUrl = process.env.REACT_APP_BASE_URL;

const Families = () => {
    const [families, setFamilies] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchFamilies();
    }, []);

    const fetchFamilies = () => {
        axiosInstance.get(`${baseUrl}/api/Families`)
            .then(res => setFamilies(res.data))
            .catch(() => console.log("Impossible de charger les familles"))
            .finally(() => setLoading(false));
    };

    const formik = useFormik({
        initialValues: {
            id: 0,
            nameAr: "",
            nameLat: "",
            descriptionAr: "",
            descriptionLat: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {
            const url = values.id
                ? `${baseUrl}/api/Families/UpdateFamily`
                : `${baseUrl}/api/Families/CreateFamily`;

            try {
                await axiosInstance.post(url, values);

                window.$("#modalForm").modal("hide");
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchFamilies();
                resetForm();
                setSelectedFamily(null);

            } catch (error) {
                // 🔴 erreurs backend (ModelState)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });
    const resetForm = () => {
        formik.resetForm();
        setSelectedFamily(null);
    };
    const handleEdit = (family) => {
        setSelectedFamily(family);
        formik.setValues(family);
        setTimeout(() => window.$("#modalForm").modal("show"), 100);
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Families/DeleteFamily`,
                    { 'id': id, 'idString': '' })
                    .then(() => fetchFamilies());
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Familles</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm"><i className="fas fa-plus"></i>Ajouter</button>

            {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title="Liste des familles"
                    columns={["nameLat", "descriptionLat"]}
                    columnsMapping={{
                        nameLat: "Nom",
                        descriptionLat: "Description",
                    }}
                    keyField="id"
                    data={families}
                    handleEdit={handleEdit}
                    handleDelete={(id) => handleDelete(id)}
                />
            )}

            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedFamily ? "Modifier" : "Ajouter"} une famille</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={resetForm}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom</label>
                            <input
                                type="text"
                                name="nameLat"
                                className={`form-control ${formik.touched.nameLat && formik.errors.nameLat
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={formik.values.nameLat}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.nameLat && formik.errors.nameLat && (
                                <div className="invalid-feedback">
                                    {formik.errors.nameLat}
                                </div>
                            )}
                            </div>
                            <div className="form-group">
                                <label>Description</label>
                                <input
                                    type="text"
                                    name="descriptionLat"
                                    className={`form-control ${formik.touched.descriptionLat && formik.errors.descriptionLat
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                    value={formik.values.descriptionLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.descriptionLat && formik.errors.descriptionLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.descriptionLat}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Families;
